import React from "react";
import { Itemservices } from "./Props";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Services = () => {
    const options = {
        loop: true,
        margin: 20,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 2500,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    }

    return (
        <>
            <div className="services-main" id="Services">
                <div className="container">
                    <div className="services-inner">
                        <div className="title1" data-aos="fade-right">
                            <div className="title-inner">
                                <span>What We Do</span>
                                <h2>Our Services</h2>
                            </div>
                        </div>
                        <div className="services-row">
                            <div className="row-inner">
                                <OwlCarousel className='owl-theme item-m' {...options}>
                                    <Itemservices titel="Portrait" t2="Portrait Photography" path="../assets/img/2-1.jpg" alt="photos" />
                                    <Itemservices titel="Wedding" t2="Wedding Photography" path="../assets/img/1-1.jpg" alt="photos" />
                                    <Itemservices titel="travel" t2="wedding Photography" path="../assets/img/3-1.jpg" alt="photos" />
                                    <Itemservices titel="Still Life" t2="Still Life Photography" path="../assets/img/40.jpg" alt="photos" />
                                    <Itemservices titel="Fashion" t2="Fashion Photography" path="../assets/img/555.jpg" alt="photos" />
                                    <Itemservices titel="Sport" t2="Sport Photography" path="../assets/img/60.jpg" alt="photos" />
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Services;